import { keymirror } from 'app/blocks/common/utils';

const ErrorEnum = keymirror({
    LICENSE_UPLOADING_FILE_IS_CORRUPTED: '',
    LICENSE_UPLOADING_TOTAL_LICENSE_FILE_SIZE_EXCEEDED: '',
});

export default ErrorEnum;
